import '../internal/packages/components-react/src/metrics';
import { createClass } from '../internal/core/wrapper-react/src/index.js';
import { TimeInput } from '../internal/components/time-input/src/index.js';
export default createClass(TimeInput);